import { Component } from '@angular/core';

@Component({
    selector: 'app-control-mapping',
    templateUrl: './control-mapping.component.html',
    styleUrls: ['./control-mapping.component.scss'],
    standalone: false
})
export class ControlMappingComponent {

}
